module.exports = __webpack_public_path__ + "static/high-performer-small-business-2022-4f56a84dbe87610c276a7f60568d2d93.svg";